module.exports = __webpack_public_path__ + "static/media/setningsminne-intro.20c2eac1.mp3";